import { themes } from 'kb-shared';
import styled from 'styled-components';
const { queries } = themes;

export const Container = styled.div`
  @media screen and ${queries.minTablet} {
    width: 386px;
  }
`;
